export const countriesThatForbidYearlyPlan: Record<string, string> = {
  BR: 'Brazil',
};

export function isYearlyPlanForbiddenInCountry(countryCode?: string) {
  return !!(countryCode && countriesThatForbidYearlyPlan[countryCode]);
}

export const usaStatesThatForbidYearlyPlan: Record<string, string> = {
  VT: 'Vermont',
};

export function isYearlyPlanForbiddenInUsaState(stateCode?: string) {
  return !!(stateCode && usaStatesThatForbidYearlyPlan[stateCode]);
}
